import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/3.jpg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonKuchanskyi = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Кучанский Александр</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>M.Sc., PhD, Dr.Sc., профессор департамента вычислений и науки о данных</MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57190488151'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-1277-8031'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», профессор департамента вычислений и науки о данных</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>
                    Проведение исследований и создание методов и моделей прогнозирования временных рядов выбросов загрязняющих веществ для задачи экологического мониторинга.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Доктор технических наук, профессор в области информационных технологий. Занимается математическим моделированием и анализом данных. Стаж по профилю — более 13 лет.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR10965311 «Smart City: интеллектуальные системы городской инфраструктуры» (2021-2023).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP13067967 «Разработка технологии микропроцессорных устройств релейной защиты» (2022-2024).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP19678730, AP19678627, AP23490123, BR24993128 — текущие проекты.
                </MyText>
            </Flex>
        </Flex>
    );
};
